import React, { useEffect } from 'react';
import { Form, Formik } from 'formik';
import { captureError } from '../../../../utils/request';
import BackForwardButtons from '../Buttons/BackNextButtons';
import Error from '../../../Error';

export default function Step(props) {
  const {
    onSubmit,
    initialValues,
    validationSchema,
    validate = null,
    handleError,
    error,
    setError,
    validateOnChange,
    validateOnBlur,
    component: Component,
    nextButtonText,
    hideBackButton = false,
  } = props;

  const validation =
    (validate && { validate }) ||
    (validationSchema && { validationSchema }) ||
    {};

  useEffect(() => {
    if (error) {
      setTimeout(() => setError(false), 3000);
    }
  }, [error, setError]);

  return (
    <Formik
      initialValues={initialValues || {}}
      {...validation}
      validateOnChange={validateOnChange}
      validateOnBlur={validateOnBlur}
      onSubmit={async (values) => {
        try {
          await onSubmit(values);
        } catch (err) {
          captureError(err);
          handleError(err);
        }
      }}
      component={({ values, setFieldValue, errors, setErrors }) => {
        return (
          <React.Fragment>
            <Form>
              <Component
                values={values}
                setFieldValue={setFieldValue}
                errors={errors}
                setErrors={setErrors}
              />
              <BackForwardButtons {...{ nextButtonText, hideBackButton }} />
              {error && <Error error={error} />}
            </Form>
          </React.Fragment>
        );
      }}
    ></Formik>
  );
}
